export const GET_LIVE_COURSE_SUCCESS = 'GET_LIVE_COURSE_SUCCESS';
export const SET_IS_REQUEST_STATUS = 'SET_IS_REQUEST_STATUS';
export const GET_LIVE_TOKEN = 'GET_LIVE_TOKEN'
